import { useState } from "react";
import { toast } from "sonner";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { Switch } from "../../components/ui/switch";
import { PageHeader, Card, Field, SalesIdChip } from "../../components/common";
import { api, errMsg } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

export default function Profile() {
  const { user, setUser } = useAuth();
  const [f, setF] = useState({ name: user.name, phone: user.phone || "", city: user.city || "", email_notifications: user.email_notifications !== false, payment_details: { method: "", account_title: "", account_number: "", bank_name: "", ...(user.payment_details || {}) } });
  const [pw, setPw] = useState({ current_password: "", new_password: "" });
  const setPd = (k) => (e) => setF({ ...f, payment_details: { ...f.payment_details, [k]: e.target.value } });
  const save = async (e) => {
    e.preventDefault();
    try { const { data } = await api.put("/profile", f); setUser(data); toast.success("Profile saved"); } catch (e2) { toast.error(errMsg(e2)); }
  };
  const changePw = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/change-password", pw); toast.success("Password changed"); setPw({ current_password: "", new_password: "" }); } catch (e2) { toast.error(errMsg(e2)); }
  };
  return (
    <div className="max-w-3xl">
      <PageHeader title="My Profile" />
      <Card className="mb-6 flex flex-wrap items-center justify-between gap-3 p-5">
        <div><p className="text-sm text-slate-500">Permanent Sales ID</p><p className="text-xs text-slate-400">Cannot be changed. Every order you book is linked to it.</p></div>
        <SalesIdChip id={user.sales_id} />
      </Card>
      <form onSubmit={save}>
        <Card className="space-y-4 p-5">
          <h2 className="font-heading text-lg font-semibold">Personal details</h2>
          <Field label="Email"><Input value={user.email} disabled className="h-11" /></Field>
          <div className="grid gap-4 sm:grid-cols-3">
            <Field label="Full name"><Input data-testid="profile-name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="h-11" /></Field>
            <Field label="Phone"><Input data-testid="profile-phone" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} className="h-11" /></Field>
            <Field label="City"><Input data-testid="profile-city" value={f.city} onChange={(e) => setF({ ...f, city: e.target.value })} className="h-11" /></Field>
          </div>
          <label className="flex items-center justify-between gap-4 rounded-lg border p-4">
            <span><span className="block font-medium">Email me updates</span><span className="text-sm text-slate-500">Order status changes, commission approvals and payments, sent to {user.email}</span></span>
            <Switch data-testid="profile-email-notifications" checked={f.email_notifications} onCheckedChange={(v) => setF({ ...f, email_notifications: v })} />
          </label>
          <h2 className="pt-4 font-heading text-lg font-semibold">Commission payment details</h2>
          <p className="text-sm text-slate-500">Where should we send your commission payments? Only you and the administrator can see this.</p>
          <div className="grid gap-4 sm:grid-cols-2">
            <Field label="Payment method">
              <Select value={f.payment_details.method} onValueChange={(v) => setF({ ...f, payment_details: { ...f.payment_details, method: v } })}>
                <SelectTrigger className="h-11" data-testid="profile-pay-method"><SelectValue placeholder="Select" /></SelectTrigger>
                <SelectContent><SelectItem value="bank_transfer">Bank transfer</SelectItem><SelectItem value="easypaisa">Easypaisa</SelectItem><SelectItem value="jazzcash">JazzCash</SelectItem><SelectItem value="cash">Cash</SelectItem></SelectContent>
              </Select>
            </Field>
            <Field label="Bank / wallet name"><Input data-testid="profile-bank" value={f.payment_details.bank_name} onChange={setPd("bank_name")} className="h-11" /></Field>
            <Field label="Account title"><Input data-testid="profile-account-title" value={f.payment_details.account_title} onChange={setPd("account_title")} className="h-11" /></Field>
            <Field label="Account / IBAN / mobile number"><Input data-testid="profile-account-number" value={f.payment_details.account_number} onChange={setPd("account_number")} className="h-11" /></Field>
          </div>
          <Button data-testid="profile-save-button" className="h-11">Save profile</Button>
        </Card>
      </form>
      <form onSubmit={changePw}>
        <Card className="mt-6 space-y-4 p-5">
          <h2 className="font-heading text-lg font-semibold">Change password</h2>
          <div className="grid gap-4 sm:grid-cols-2">
            <Field label="Current password"><Input type="password" data-testid="profile-current-pw" required value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })} className="h-11" /></Field>
            <Field label="New password"><Input type="password" data-testid="profile-new-pw" required minLength={8} value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} className="h-11" /></Field>
          </div>
          <Button variant="outline" data-testid="profile-change-pw-button" className="h-11">Change password</Button>
        </Card>
      </form>
    </div>
  );
}
